/**
 * @generated SignedSource<<9054e586fbfe8617372e9e41695befdc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddSegmentInput = {
  clientMutationId?: string | null;
  screenerId: string;
};
export type ProjectSegmentsPage_AddSegment_Mutation$variables = {
  input: AddSegmentInput;
};
export type ProjectSegmentsPage_AddSegment_Mutation$data = {
  readonly addSegment: {
    readonly screener: {
      readonly segments: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"Segment_segment">;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};
export type ProjectSegmentsPage_AddSegment_Mutation = {
  response: ProjectSegmentsPage_AddSegment_Mutation$data;
  variables: ProjectSegmentsPage_AddSegment_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSegmentsPage_AddSegment_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddSegmentPayload",
        "kind": "LinkedField",
        "name": "addSegment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ScreenerNode",
            "kind": "LinkedField",
            "name": "screener",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SegmentNodeConnection",
                "kind": "LinkedField",
                "name": "segments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SegmentNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SegmentNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Segment_segment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectSegmentsPage_AddSegment_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddSegmentPayload",
        "kind": "LinkedField",
        "name": "addSegment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ScreenerNode",
            "kind": "LinkedField",
            "name": "screener",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SegmentNodeConnection",
                "kind": "LinkedField",
                "name": "segments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SegmentNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SegmentNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "condition",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quota",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "count",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "terminate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "26f474631aca9f0bd1b124101a49b8e7",
    "id": null,
    "metadata": {},
    "name": "ProjectSegmentsPage_AddSegment_Mutation",
    "operationKind": "mutation",
    "text": "mutation ProjectSegmentsPage_AddSegment_Mutation(\n  $input: AddSegmentInput!\n) {\n  addSegment(input: $input) {\n    screener {\n      segments {\n        edges {\n          node {\n            ...Segment_segment\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment Segment_segment on SegmentNode {\n  id\n  condition\n  text\n  quota\n  count\n  terminate\n}\n"
  }
};
})();

(node as any).hash = "11c421d3decec877586a3cdb114b5f19";

export default node;
